module.exports = __webpack_public_path__ + "img/a08228f4cd4f584c34865bf633a3c8b.5bf1873b.png";